import { Controller } from "@hotwired/stimulus"

// Scroll only the chip row, preserving the page's vertical position.
export default class extends Controller {
    connect() {
        this.observer = new ResizeObserver(() => this.reveal())
        this.observer.observe(this.element)
        this.reveal()
    }
    disconnect() { this.observer.disconnect() }
    reveal() {
        const active = this.element.querySelector('[aria-current="page"]')
        if (!active) return
        const row = this.element.getBoundingClientRect()
        const chip = active.getBoundingClientRect()
        if (chip.right > row.right) this.element.scrollLeft += chip.right - row.right
        else if (chip.left < row.left) this.element.scrollLeft -= row.left - chip.left
    }
}
